export default __webpack_public_path__ + "static/media/opportunityTable.a7b7021c.png";